<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7 1a6 6 0 0 1 4.714 9.713L16 15l-1 1-4.287-4.286A6 6 0 1 1 7 1zm0 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-search',
});
</script>
